export const featuredProducts = [
  {
    id: 1,
    brand: 'La Roche-Posay',
    name: 'Sérum Hyalu B5',
    category: 'Sérum Hidratante',
    image: 'https://static.readdy.ai/image/0c9ab602efd3f666fe992585e0daf840/9f660df1c8c77f65aa5602dbb868b9ea.jpeg',
    certified: true,
    certType: 'Dermatológicamente Aprobado',
    description: 'Rellena arrugas, restaura la elasticidad y proporciona hidratación profunda duradera con ácido hialurónico puro y vitamina B5.'
  },
  {
    id: 2,
    brand: 'La Roche-Posay',
    name: 'Mela B3 Serum',
    category: 'Sérum Anti-Manchas',
    image: 'https://public.readdy.ai/ai/img_res/dbbdc7a9-c82f-42bf-a4cf-95b5132be8f0.jpg',
    certified: true,
    certType: 'Dermatológicamente Aprobado',
    description: 'Sérum anti-manchas con niacinamida y ácido tranexámico. Reduce visiblemente manchas oscuras, unifica el tono y mejora la luminosidad de la piel con uso continuo.'
  },
  {
    id: 3,
    brand: 'La Roche-Posay',
    name: 'Vitamina C10 Sérum',
    category: 'Sérum Iluminador',
    image: 'https://static.readdy.ai/image/0c9ab602efd3f666fe992585e0daf840/9e190011516aeab0a21dcdc70eeba70b.jpeg',
    certified: true,
    certType: 'Dermatológicamente Aprobado',
    description: 'Sérum iluminador con vitamina C pura al 10%. Unifica el tono, reduce manchas oscuras y aporta luminosidad y vitalidad a la piel apagada.'
  },
  {
    id: 4,
    brand: 'La Roche-Posay',
    name: 'Cicaplast Baume B5+',
    category: 'Bálsamo Reparador',
    image: 'https://public.readdy.ai/ai/img_res/337eb825-91db-4c0f-b0f2-c7f13a6ddecc.jpg',
    certified: true,
    certType: 'Dermatológicamente Aprobado',
    description: 'Bálsamo multireparador enriquecido con pantenol y madecassoside. Calma, protege y regenera pieles irritadas, secas y sensibles.'
  },
  {
    id: 5,
    brand: 'La Roche-Posay',
    name: 'Effaclar Serum',
    category: 'Sérum Anti Imperfecciones',
    image: 'https://public.readdy.ai/ai/img_res/38926daf-fb90-4d99-8f27-1b3984ee2a71.jpg',
    certified: true,
    certType: 'Dermatológicamente Aprobado',
    description: 'Formulado con AHA, BHA y LHA para ayudar a reducir poros visibles, puntos negros e imperfecciones, dejando la piel más lisa y uniforme.'
  },
  {
    id: 6,
    brand: 'La Roche-Posay',
    name: 'Sérum Retinol B3',
    category: 'Sérum Anti-Edad',
    image: 'https://static.readdy.ai/image/0c9ab602efd3f666fe992585e0daf840/b31bc159ecb5b515289bb30c6f281472.jpeg',
    certified: true,
    certType: 'Dermatológicamente Aprobado',
    description: 'Combina retinol puro y niacinamida para reducir visiblemente arrugas, manchas y mejorar la textura de la piel con uso continuo.'
  }
];

export const skincareTips = [
  {
    id: 1,
    title: 'Sérum Hyalu B5',
    description: 'Sérum concentrado con ácido hialurónico puro y vitamina B5. Rellena arrugas, restaura la elasticidad y proporciona hidratación profunda duradera.',
    icon: 'ri-drop-fill',
    badge: 'Hidratación Intensa'
  },
  {
    id: 2,
    title: 'Mela B3 Serum',
    description: 'Sérum anti-manchas con niacinamida y ácido tranexámico. Reduce visiblemente manchas oscuras, unifica el tono y mejora la luminosidad de la piel.',
    icon: 'ri-contrast-2-line',
    badge: 'Anti-Manchas'
  },
  {
    id: 3,
    title: 'Vitamina C10 Sérum',
    description: 'Sérum iluminador con vitamina C pura al 10%. Unifica el tono, reduce manchas oscuras y aporta luminosidad y vitalidad a la piel apagada.',
    icon: 'ri-sun-fill',
    badge: 'Iluminador'
  },
  {
    id: 4,
    title: 'Cicaplast Baume B5+',
    description: 'Bálsamo multireparador enriquecido con pantenol y madecassoside. Calma, protege y regenera pieles irritadas, secas y sensibles.',
    icon: 'ri-heart-pulse-line',
    badge: 'Reparador'
  },
  {
    id: 5,
    title: 'Effaclar Serum',
    description: 'Formulado con AHA, BHA y LHA para reducir poros visibles, puntos negros e imperfecciones, dejando la piel más lisa y uniforme.',
    icon: 'ri-shield-check-line',
    badge: 'Anti-Imperfecciones'
  },
  {
    id: 6,
    title: 'Sérum Retinol B3',
    description: 'Combina retinol puro y niacinamida para reducir visiblemente arrugas, manchas y mejorar la textura de la piel con uso continuo.',
    icon: 'ri-time-line',
    badge: 'Anti-Edad'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Andrea Solano',
    location: 'San José, Costa Rica',
    rating: 5,
    comment: 'Llevo 3 meses usando el sérum Hyalu B5 de La Roche-Posay que compré aquí y mi piel nunca había estado tan hidratada. La calidad de los productos de distribuidores autorizados es incomparable con lo que se consigue localmente.',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20costa%20rican%20woman%20in%20her%20thirties%20with%20radiant%20healthy%20glowing%20skin%2C%20natural%20beauty%20portrait%20with%20soft%20warm%20lighting%20and%20clean%20white%20background%2C%20confident%20friendly%20smile&width=120&height=120&seq=test1cr&orientation=squarish'
  },
  {
    id: 2,
    name: 'Valeria Mora',
    location: 'Heredia, Costa Rica',
    rating: 5,
    comment: 'Excelente servicio y productos auténticos. El Effaclar Sérum transformó mi piel con acné en pocas semanas. Muy feliz de tener acceso a estas marcas en Costa Rica.',
    avatar: 'https://readdy.ai/api/search-image?query=young%20costa%20rican%20woman%20in%20her%20twenties%20with%20clear%20beautiful%20skin%2C%20natural%20beauty%20portrait%20with%20soft%20natural%20lighting%20and%20minimalist%20white%20background%2C%20warm%20smile&width=120&height=120&seq=test2cr&orientation=squarish'
  },
  {
    id: 3,
    name: 'Marcela Jiménez',
    location: 'Cartago, Costa Rica',
    rating: 5,
    comment: 'Compro al por mayor para mi spa y siempre recibo productos originales con excelente precio. El Anthelios es el favorito de mis clientes. Totalmente recomendado.',
    avatar: 'https://readdy.ai/api/search-image?query=elegant%20costa%20rican%20woman%20in%20her%20forties%20with%20beautiful%20healthy%20skin%2C%20professional%20portrait%20photography%20with%20soft%20natural%20lighting%20and%20clean%20background%2C%20sophisticated%20appearance&width=120&height=120&seq=test3cr&orientation=squarish'
  }
];
